import { Box, Hidden } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import FloatingChatBox from 'components/messages/floating-chat-box'

const NivosBody: React.FC<PropsWithChildren> = props => {
  const [chatBoxHidden, setChatBoxHidden] = React.useState(true)
  const isMobileView = useMediaQuery('(max-width:600px)')
  const location = useLocation()
  return (
    <Box display={'flex'} flexGrow={1} paddingTop={isMobileView ? 10 : '58px'}>
      {location.pathname !== '/messages' && (
        <Hidden smDown>
          <FloatingChatBox
            hidden={chatBoxHidden}
            setHidden={setChatBoxHidden}
          />
        </Hidden>
      )}
      {props.children}
    </Box>
  )
}

export default NivosBody
